import React, { useState } from "react";
import SearchAll from "../search-all";

import algoliasearch from "algoliasearch/lite";
import {
  InstantSearch,
  SearchBox,
  Hits,
  useInstantSearch,
} from "react-instantsearch";

const searchClient = algoliasearch(
  "G0VLPZK1K5",
  "1d5ab2118d90a0ca1794dc8c22845f51"
);

function EmptyQueryBoundary({ children, fallback }) {
  const { indexUiState } = useInstantSearch();
  if (!indexUiState.query) {
    return fallback;
  }
  return children;
}

function NoResultsBoundary({ children, fallback }) {
  const { results } = useInstantSearch();

  if (!results.__isArtificial && results.nbHits === 0) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }

  return children;
}

function NoResults() {
  const { indexUiState } = useInstantSearch();

  return (
    <div className="mt-6 text-center">
      <p>
        No results for <q>{indexUiState.query}</q>.
      </p>
    </div>
  );
}

const Search = ({ page }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    document.body.classList.add("modal-open");
    setIsOpen(true);
  };
  const toggleClose = () => {
    document.body.classList.remove("modal-open");
    setIsOpen(false);
  };
  const escapeCheck = (event) => {
    if (event.key === "Escape") {
      toggleClose();
    }
  };

  const [showHits, setShowHits] = useState(false);

  return (
    <>
      <button
        className={"search" + (page === "page" ? " page" : "")}
        onClick={toggleOpen}
        role="button"
        aria-label="Open Search modal"
        aria-expanded={isOpen}
      >
        <i className="fa-solid fa-magnifying-glass" />
      </button>
      {isOpen ? (
        <>
          <div
            className="modal-overlay search-overlay"
            onClick={toggleClose}
          ></div>
          <div onKeyDown={escapeCheck} className="modal search-m">
            <InstantSearch searchClient={searchClient} indexName="All_site">
              <div className="search-wrapper flex justify-content align-center">
                <SearchBox
                  autoFocus
                  placeholder="Search..."
                  insights
                  onKeyDown={() => setShowHits(true)}
                />
                <button className="close" onClick={toggleClose}>
                  Cancel
                </button>
              </div>

              <EmptyQueryBoundary fallback={null}>
                <NoResultsBoundary fallback={<NoResults />}>
                  {showHits ? <Hits hitComponent={SearchAll} /> : ""}
                </NoResultsBoundary>
              </EmptyQueryBoundary>
            </InstantSearch>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Search;
